import React from 'react';
import Timeline from '../../components/Timeline/Timeline';
import FontAwesome from 'react-fontawesome';
import AppStoreBadges from '../../components/AppStoreBadges/AppStoreBadges';

const GetTheApp = () => {
    return (
        <Timeline
            heading="get the mobile app"
            icon={
                <FontAwesome
                    className="primary-yellow con md image_center icon20"
                    name="mobile"
                    datacy="mobile"
                    size="2x"
                />
            }>
            After you create a Safeco account, download our mobile app for access to ID cards, your
            policies, claim reporting, and more. All while you are on the go!
            <br />
            <div className="appStoreBadges">
                <AppStoreBadges brand="Apple" datacy="app-store" />
                <AppStoreBadges
                    brand="Google"
                    text="Get it on Google Play"
                    datacy="google-play-store"
                />
            </div>
        </Timeline>
    );
};

export default GetTheApp;



// WEBPACK FOOTER //
// ./src/containers/GetTheApp/GetTheApp.jsx